// extracted by css-extract-rspack-plugin
export default {"datafeedContainer":"datafeedContainer-Ycknjy"};